import styled, { keyframes } from 'styled-components';
import { theme } from 'styled-tools';

import { Text } from '@calm-web/design-system';

import LimitedTimeCalloutRaw from '@/components/PreSignupFlow/Components/LimitedTimeCallout';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

export const Wrapper = styled.div<{
	isVisible: boolean;
}>`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: white;
	padding: 20px;
	opacity: ${p => (p.isVisible ? '1' : '0')};
	pointer-events: ${p => (p.isVisible ? '' : 'none')};
	transition: opacity ${theme('animation.transition')};
	overflow-y: scroll;
	z-index: ${p => theme('modal.zIndex')(p) - 1};
	text-align: center;
`;

export const Container = styled.div<{
	activeScreen: boolean;
}>`
	max-width: 560px;
	margin: auto;
	display: ${p => (p.activeScreen ? 'flex' : 'none')};
	flex-direction: column;
`;

export const PaymentSubHeading = styled(Text)`
	margin-top: 10px;
	margin-bottom: 30px;
`;

export const LimitedTimeCallout = styled(LimitedTimeCalloutRaw)`
	justify-self: center;
	margin: 20px auto 0;
`;

export const PaymentTitleHeading = styled(Text)`
	margin-bottom: 0;
	margin-right: 8px;
`;

export const PaymentTitleWrapper = styled.div`
	align-items: flex-end;
	display: flex;
	margin-bottom: 8px;
`;
